//? remote components
import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import AlarmIcon from '@/assets/icon-alarm.svg?react';

const IconAlarm = observer(({ active, disabled, ...rest }) => {
  return (
    <IconAlarmContainer
      className={cn({
        active,
        disabled,
      })}
      {...rest}
    />
  );
});

const IconAlarmContainer = styled(props => <AlarmIcon {...props} />)`
  &.active {
    path {
      fill: #22bbe8;
    }
  }

  &.disabled {
    path {
      fill: #495769;
    }
  }
`;

export default IconAlarm;
